export default __webpack_public_path__ + "static/OpenSansRegular-0fd948558f26d7d4d70444915781fe7a.svg";